import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootState";
import NotificationDialog from "../shared/NotificationDialog";
import * as Actions from "../../store/actions";

export interface GlobalNotificationDialogProps {
}

export default function GlobalNotificationDialog(props: GlobalNotificationDialogProps): JSX.Element {
    const notificationInfo = useSelector((state: RootState) => state.appState.globalNotification);

    return <NotificationDialog
        notificationType={notificationInfo?.type}
        isOpen={!!notificationInfo?.message}
        title={notificationInfo?.title}
        message={notificationInfo?.message}
        isCritical={notificationInfo?.isCritical}
        canDismiss={notificationInfo?.canDismiss}
        onDismiss={() => {
            Actions.clearGlobalNotification();
            notificationInfo?.onDismiss?.();
        }}
    />
}
